import React, { useState, useEffect } from "react";
import { AuthService } from "../../../services";
import ReactPaginate from "react-paginate";
import { Button, Table } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { injectModels } from "../../../redux/injectModels";
import { toast } from "react-toastify";
import { TraderUnitService } from "../../../services";
import CustomModal from "../../../components/Modal/Modal";
import TraderUnitShopfrontMapping from "./TraderUnitShopfrontMapping";
import {
  addDefaultImg,
  formatAmount,
  handleConsoleError,
} from "../../../utils/common-methods";

const TraderUnitShopfront = (props) => {
  const loginUser = AuthService.getLoginUser();
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  //const [linkAccountData, setLinkedAccountData] = useState(null);

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  //const selectedUnit = TraderUnitService.getSelectedTraderUnit();

  const { unitId } = useParams(); //SelectedUnitId

  useEffect(() => {
    getShopFrontData();
  }, []);

  const getShopFrontData = async () => {
    try {
      if (loginUser) {
        props.application.setLoading(true);
        const res = await TraderUnitService.getTraderUnitShopfront(
          loginUser?.id,
          unitId,
          true
        );
        if (res?.isSuccess && res?.data?.length > 0) {
          setFilteredData(res?.data);
        } else {
          setFilteredData([]);
        }
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  //****** Add New Data *********/
  const handleCreateShopFront = async (e) => {
    try {
      setModalOpen(true);
    } catch (error) {
      console.log("error", error);
    }
  };

  //************* Delete Method ******** */
  const handleDelete = async (productId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to remove this shopfront from unit?"
    );
    if (!confirmDelete) {
      return;
    }
    try {
      props.application.setLoading(true);
      const response = await TraderUnitService.deleteTraderUnitShopfront(
        unitId,
        productId
      );
      if (response?.isSuccess) {
        toast.success("Record deleted successfully");
        await getShopFrontData();
      } else {
        toast.error(response?.message || "Failed to delete the record");
      }
    } catch (error) {
      const message=handleConsoleError(error)
      toast.error(
        error?.message || message
      );
    } finally {
      props.application.setLoading(false);
    }
  };

  const closeModal = async () => {
    setModalOpen(false);
    await getShopFrontData();
  };

  return (
    <React.Fragment>
      <CustomModal size="lg" isOpen={isModalOpen} onClose={closeModal}>
        {/* <TraderUnitShopfrontMapping></TraderUnitShopfrontMapping> */}
        <TraderUnitShopfrontMapping onClose={closeModal} />
      </CustomModal>
      <section className="edit-form-table">
        <div className="container mt-3">
          <div className="verifier-buttton">
            <Button onClick={handleCreateShopFront}>Add Items To Unit</Button>{" "}
          </div>
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Product Title</th>
                  <th>Description</th>
                  <th>Image</th>
                  <th>Price</th>
                  {/* <th>Status</th> */}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData && paginatedData.length > 0 ? (
                  <React.Fragment>
                    {paginatedData.map((item, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{calculateSNo(idx)}</td>
                          <td>{item?.productTitle}</td>

                          <td>{item?.productDescription}</td>
                          <td>
                            <img
                              className="img-fluid"
                              style={{
                                maxWidth: "100px",
                              }}
                              alt=""
                              src={item?.imageUrl}
                              onError={addDefaultImg}
                            ></img>
                          </td>
                          <td>£{formatAmount(item?.price)}</td>
                          {/* <td>
                            {item.status === true ? (
                              <i className="ri-check-fill"></i>
                            ) : (
                              <i className="ri-close-circle-line"></i>
                            )}
                          </td> */}

                          <td>
                            <div className="delete-create">
                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleDelete(item?.id);
                                }}
                                style={{ marginRight: "10px" }}
                              >
                                <i className="ri-delete-bin-line"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ) : (
                  <tr>
                    <td colSpan="10 mt-2">No results found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="table-footer">
            <p className="mb-3">
              <strong>Total Count: {filteredData.length}</strong>
            </p>
            {filteredData.length === 0 ? "" : renderPagination()}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(TraderUnitShopfront);
